import { DocumentData, FirestoreDataConverter, QueryDocumentSnapshot, serverTimestamp, SnapshotOptions, Timestamp } from 'firebase/firestore';
import { SalaryDeduction } from '../types/SalaryDeduction';
import { FirebaseSalaryDeduction } from '../types/firebase/FirebaseSalaryDeduction';
import { firestore } from 'firebase-admin';
import { DateTime } from 'luxon';

export const salaryDeductionConverter: FirestoreDataConverter<SalaryDeduction> = {
    toFirestore: function (salaryDeduction: SalaryDeduction): DocumentData {
        let data: FirebaseSalaryDeduction = {
            id: salaryDeduction.id,
            idNumber: salaryDeduction.idNumber,
            numDays: salaryDeduction.numDays,
            reason: salaryDeduction.reason,
            date: Timestamp.fromMillis(salaryDeduction.date.toMillis()),
            lastUpdate: serverTimestamp(),
        }
        return data;
    },
    fromFirestore: function (snapshot: QueryDocumentSnapshot<DocumentData>, options?: SnapshotOptions): SalaryDeduction {
        let data: FirebaseSalaryDeduction = snapshot.data(options) as FirebaseSalaryDeduction;
        return {
            id: data.id,
            idNumber: data.idNumber,
            numDays: data.numDays,
            reason: data.reason,
            date: DateTime.fromMillis(data.date.toMillis()),
            lastUpdate: DateTime.fromMillis((data.lastUpdate as Timestamp).toMillis()),
        };
    }
}
